import { useEffect } from 'react';
import { SPOTIFY_CODE, SPOTIFY_USER_INFO } from '../../constants/storage';
import { addItemToStorage } from '../../utils';
import { LoaderPageStyle } from '../Login/ShiftPage.style';

export default function Callback() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const error = url.searchParams.get('error');
    const userState = url.searchParams.get('state');

    const resolveHomePath = () => {
      let redirectPath = '/home';
      try {
        const stored = localStorage.getItem('postSpotifyRedirect');
        if (stored && stored.startsWith('/') && !stored.startsWith('//')) {
          redirectPath = stored;
        }
      } catch {
        // keep /home
      }
      return redirectPath;
    };

    if (error === 'access_denied') {
      localStorage.setItem(
        'SPOTIFY_RECONNECT_NOTICE',
        'Spotify authorization was cancelled. Click Reconnect when you are ready.'
      );
      window.location.replace(resolveHomePath());
      return;
    }

    if (error) {
      localStorage.setItem(
        'SPOTIFY_RECONNECT_NOTICE',
        `Spotify authorization failed (${error}). Please try Reconnect again.`
      );
      window.location.replace(resolveHomePath());
      return;
    }

    if (code) {
      // Persist the one-time code, then leave /callback so App.tsx exchanges it once on /home.
      addItemToStorage(SPOTIFY_CODE, code);
      addItemToStorage('SPOTIFY_CODE_TIMESTAMP', Date.now().toString());
      if (userState) {
        addItemToStorage(SPOTIFY_USER_INFO, userState);
      }
      window.location.replace('/home');
      return;
    }

    localStorage.setItem(
      'SPOTIFY_RECONNECT_NOTICE',
      'Spotify did not return an authorization code. Please try Reconnect again.'
    );
    window.location.replace(resolveHomePath());
  }, []);

  return (
    <LoaderPageStyle>
      <div className="loadingPage">
        <h1>Taking you to Songplace</h1>
        <div className="loadingDiv">
          <div className="loadingCircle"></div>
        </div>
      </div>
    </LoaderPageStyle>
  );
}
